/* eslint-disable sort-keys-fix/sort-keys-fix */
import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';
import { DATE_TIME_ISO_SCHEMA } from '../rxdb.constants';

const questionnaireResponseSchemaLiteral = {
  title: 'Questionnaire Response',
  version: 0,
  description: 'Schema for questionnaire responses',
  primaryKey: 'uniqueId',
  type: 'object',
  properties: {
    id: { type: 'string' },
    uniqueId: { type: 'string', maxLength: 100 },
    createdAt: DATE_TIME_ISO_SCHEMA,
    updatedAt: DATE_TIME_ISO_SCHEMA,
    associatedWithId: { type: ['string', 'null'] },
    index: { type: 'number' },
    value: {
      anyOf: [
        { type: 'string' },
        { type: 'number' },
        { type: 'boolean' },
        { type: 'object', properties: {}, additionalProperties: true },
        {
          type: 'array',
          items: {
            anyOf: [
              { type: 'string' },
              { type: 'number' },
              { type: 'boolean' },
              { type: 'object', properties: {}, additionalProperties: true },
              { type: 'null' },
            ],
          },
        },
        { type: 'null' },
      ],
    },
    visible: { type: 'boolean' },
    fieldTemplate: {
      type: 'object',
      properties: {
        aiDeduplicationLogic: { type: ['string', 'null'] },
        key: { type: 'string' },
        label: { type: 'string' },
        options: {
          anyOf: [
            {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  key: { type: 'string' },
                  label: { type: 'string' },
                  isDefault: { type: 'boolean' },
                  pdfFillKey: { type: 'string' },
                },
                additionalProperties: true,
              },
            },
            {
              type: 'object',
              properties: {},
              additionalProperties: true,
            },
            { type: 'null' },
          ],
        },
        type: { type: 'string' },
        id: { type: 'string' },
        listFieldTemplateId: { type: ['string', 'null'] },
      },
      additionalProperties: true,
    },
    fieldTemplateId: { type: 'string' },
    source: { type: 'string' },
    submittedById: { type: ['string', 'null'] },
    listRowResponseId: { type: ['string', 'null'] },
    questionnaireId: { type: 'string', maxLength: 100 },
    listResponses: {
      type: ['array', 'null'],
      items: {
        type: 'object',
        properties: {},
        additionalProperties: true,
      },
    },
  },
  required: ['id', 'uniqueId', 'createdAt', 'updatedAt', 'questionnaireId'],
  indexes: ['questionnaireId'],
} as const;

const schemaTyped = toTypedRxJsonSchema(questionnaireResponseSchemaLiteral);

export type RxQuestionnaireResponseDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const questionnaireResponseSchema: RxJsonSchema<RxQuestionnaireResponseDocType> = questionnaireResponseSchemaLiteral;
